import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME } from './constants';


class SestavyApi extends BaseApi {
	async GetDailyPerformanceReport(Parameters: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/WorkInProgress/GetDailyPerformanceReport/?${Parameters}&ColumnSequence=${columnsSeq}`, 'DailyPerformanceReport.xlsx');
	}

	constructor() {
		super(DMS_MODULE, API_NAME);
	}
}


export const apiProvider = new SestavyApi();
